module.exports = __webpack_public_path__ + "static/media/using_dots.06fe691c.png";